import React, { useEffect, useState } from 'react';
import { utils } from '../utils';
import { theme } from '../constants';

interface ButtonProps {
  title: string;
  onClick?: () => void;
  colorScheme?: 'dark' | 'light';
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  vibrationDuration?: number;
  isLoading?: boolean;
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  title,
  style,
  onClick,
  colorScheme = 'dark',
  containerStyle,
  vibrationDuration = 50,
  isLoading = false,
  disabled = false,
}) => {
  const [canVibrate, setCanVibrate] = useState(false);

  useEffect(() => {
    setCanVibrate('vibrate' in navigator);
  }, []);

  const handleClick = () => {
    if (isLoading || disabled) return;
    
    if (canVibrate) {
      navigator.vibrate(vibrationDuration);
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <div style={{ ...containerStyle }}>
      <button
        onClick={handleClick}
        disabled={isLoading || disabled}
        style={{
          width: '100%',
          color:
            colorScheme === 'dark' ? theme.colors.white : theme.colors.mainDark,
          height: 40,
          textAlign: 'center',
          fontSize: 16,
          borderRadius: 36,
          textTransform: 'capitalize',
          border: colorScheme === 'dark' ? 'none' : '1px solid #FFD9C3',
          background:
            colorScheme === 'dark' ? theme.colors.mainDark : '#FFD9C3',
          cursor: (isLoading || disabled) ? 'not-allowed' : 'pointer',
          opacity: (isLoading || disabled) ? 0.5 : 1,
          position: 'relative',
          ...utils.flexCenter(),
          ...theme.fonts.Poppins_600SemiBold,
          ...style,
        }}
      >
        <div style={{
          visibility: isLoading ? 'hidden' : 'visible',
        }}>
          {title}
        </div>
        
        {isLoading && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div className="loader" style={{
              width: '20px',
              height: '20px',
              border: '2px solid',
              borderColor: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
              borderTopColor: colorScheme === 'dark' ? '#ffffff' : theme.colors.mainDark,
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
            }} />
          </div>
        )}
      </button>
      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};